module.exports = __webpack_public_path__ + "static/lithic-spear-f7e692112536bd7036696f5667ead2e7.png";